// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2e4d2756","453":"a0db212d","796":"43590fb9"}[chunkId] + ".chunk.js";
};